const state = {
  data: null,
  info: null
}

const getters = {
  user: state => (state.data ? { ...state.data } : state.data),
  userInfo: state => (state.info ? { ...state.info } : state.info)
}

const types = {
  setUser: 'user/setUser',
  setUserInfo: 'user/setUserInfo'
}

const mutations = {
  [types.setUser] (state, object) {
    state.data = object
  },
  [types.setUserInfo] (state, object) {
    state.info = object
  }
}

const actions = {
  setUserAction ({commit}, object) {
    commit(types.setUser, object)
  },
  setUserInfoAction ({commit}, object) {
    commit(types.setUserInfo, object)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js